import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSortDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M5.47 11.47a.75.75 0 0 1 1.06 0l2.72 2.72V4a.75.75 0 1 1 1.5 0v10.19l2.72-2.72a.75.75 0 1 1 1.06 1.06L10 17.06l-4.53-4.53a.75.75 0 0 1 0-1.06"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSortDown;
